var messages = {
  placeholder: '選択して下さい',
  noOptions: 'オプションなし'
};
export default messages;